<template>
  <div class="footer">
    <!-- 内框 -->
    <div class="Inside">
      <!-- 底部文字 左侧 -->
      <div class="footer_text">
        <ul class="footer_ul">
          <!-- <li>首页</li> -->
          <!-- <li>全部课程</li> -->
          <!-- TODO 注释 宠播社区 -->
          <!-- <li>宠播社区</li> -->
        </ul>
        <!-- 地址--联系电话---邮箱 -->
        <div class="distance">
          <div class="contactInfo">
            <img src="../../assets/img/电话咨询-电话.png" alt="" />
            <!-- <span class="el-input__icon el-icon-search"></span> -->
            <p>咨询热线：028-60232036 转 8063</p>
          </div>
          <div class="contactInfo">
            <img src="../../assets/img/邮箱 (1).png" alt="" />
            <!-- <span class="el-input__icon el-icon-search"></span> -->
            <p>电子邮箱：sales@seamaty.com</p>
          </div>
          <div class="contactInfo">
            <img src="../../assets/img/地址.png" alt="" />
            <!-- <span class="el-input__icon el-icon-search"></span> -->
            <p>地址：四川省成都市高新(西)区合作路333号</p>
          </div>
        </div>
      </div>
      <!-- 右侧 二维码 -->
      <div class="QrCode">
        <img
          src="../../assets/img/官网二维码.jpg"
          style="width:160px;height:161px"
          alt=""
        />
        <p>关注公众号</p>
      </div>
    </div>
    <!-- 内框--- 备案号:蜀ICP备18027379号-5 -->
    <div class="ForTheRecord">
      <a href="https://beian.miit.gov.cn/#/Integrated/index"
        >成都斯马特科技有限公司 蜀ICP备2026011211号-3 Copyright ©2012-2022
        vetpoder.com</a
      >
    </div>
    <!-- 返回顶部 -->
    <div v-show="ShowBackToTop" class="absolut" @click="handle">
      <a href="javascript:window.scrollTo( 0, 0 );">
        <img src="../../assets/img/组 3.png" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    ShowBackToTop: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    handle() {
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    }
  }
};
</script>

<style lang="less" scoped>
// 返回顶部
.absolut {
  position: fixed;
  top: 500px;
  right: 85px;
  img {
    width: 66px;
    height: 66px;
  }
}
.footer {
  position: relative;
  // bottom: 0px;
  // margin-top: 1100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  // padding-top: 56px;
  // width: 1920px;
  // height: 358px;
  height: 320px;
  background: #071727;
  .Inside {
    margin: auto;
    margin-bottom: 0px !important;
    width: 1380px;
    // height: 233px;
    height: 220px;
    // background: #fff;
    border-bottom: 1px solid #243341;
    display: flex;
    justify-content: space-between;
  }
}
// 文字
.footer_text {
  margin: 0px 0px 58px 0px;
  width: 304px;
  height: 176px;
  background: #071727;
}
// 底部导航
.footer_ul {
  display: flex;
  list-style: none;
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  padding: 0px;
  margin: 0px !important;
  li {
    margin-right: 57px;
  }
}
// 导航栏
.footer_ul li:nth-child(3) {
  margin-right: 0px !important;
}
// 联系方式
.contactInfo {
  margin-top: 18px;
  display: flex;
  font-size: 14px;
  span {
    // margin-top: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    color: #959595;
  }
  p {
    margin: 0px;
    color: #959595;
  }
}
// 宽高
.distance {
  margin-top: 57px;
  width: 304px;
  height: 100px;
  img {
    margin-right: 10px;
  }
}
//二维码
.QrCode {
  p {
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #959595;
  }
}
// 备案号
.ForTheRecord {
  margin: 27px 0px 25px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #959595;
  p {
    margin: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout_font/footers/footers.vue